export function ProgramService($http, apexApiUrl) {
    'ngInject';
    return {
        retrievePrograms: retrievePrograms
    };

    function retrievePrograms(params) {
        return $http({
            method: "GET",
            url: `${apexApiUrl}/programs`,
            params
        })
            .then(response => response.data);
    }
}
